import { useMemo, useCallback } from 'react';

export const useLogger = () => {
  const debug = useCallback((message: unknown) => console.debug(message), []);
  const info = useCallback((message: unknown) => console.info(message), []);
  const warn = useCallback((message: unknown) => console.warn(message), []);
  const error = useCallback((message: unknown) => console.error(message), []);

  return useMemo(
    () => ({ debug, info, warn, error }),
    [debug, info, warn, error],
  );
};
